import { render, staticRenderFns } from "./NotifyHeaderButton.vue?vue&type=template&id=0085480a&scoped=true&"
import script from "./NotifyHeaderButton.vue?vue&type=script&lang=js&"
export * from "./NotifyHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085480a",
  null
  
)

export default component.exports